<div class="responses-layout">
  <app-response-trial-banner></app-response-trial-banner>
  <div class="responses-body">
    <div class="responses-sidebar" [class.responses-sidebar--hidden]="showEmptyState">
      <app-response-projects-list
        [activeProjectId]="activeProjectId"
        (projectSelect)="onProjectSelect($event)"
        (projectsLoaded)="onProjectsLoaded($event)"
      ></app-response-projects-list>
    </div>

    <div class="responses-main">
      @if (showEmptyState) {
        <app-response-project-wizard [documentSubtypes]="documentSubtypes"></app-response-project-wizard>
      } @else {
        <div class="responses-outlet">
          <router-outlet></router-outlet>
        </div>
      }
    </div>
  </div>
</div>
